import {Expose} from "class-transformer";

export default class ModelTransferService {
	@Expose({name: "id"})
	private readonly _id: number;

	@Expose({name: "uuid"})
	private readonly _uuid: string;

	@Expose({name: "itgType"})
	private readonly _itgType: string;

	@Expose({name: "companyId"})
	private readonly _companyId: number;

	@Expose({name: "name"})
	private readonly _name: string;

	@Expose({name: "slug"})
	private readonly _slug: string;

	@Expose({name: "logoUrl"})
	private readonly _logoUrl: string | null;

	@Expose({name: "isActive"})
	private readonly _isActive: boolean;

	@Expose({name: 'link'})
	private readonly _link: string | null = null;

	constructor(
		id: number,
		uuid: string,
		itgType: string,
		companyId: number,
		name: string,
		slug: string,
		logoUrl: string,
		isActive: boolean
	) {
		this._id = id;
		this._uuid = uuid;
		this._itgType = itgType;
		this._companyId = companyId;
		this._name = name;
		this._slug = slug;
		this._logoUrl = logoUrl;
		this._isActive = isActive;
	}

	public get id() {
		return this._id;
	}

	public get uuid() {
		return this._uuid;
	}

	public get itgType() {
		return this._itgType;
	}

	public get companyId() {
		return this._companyId;
	}

	public get name() {
		return this._name;
	}

	public get slug() {
		return this._slug;
	}

	public get logoUrl() {
		return this._logoUrl;
	}

	public get isActive() {
		return this._isActive;
	}

	public get link(): string | null {
		return this._link;
	}
}
